import React, { useState, useEffect, useMemo } from 'react';
import { Table, Button, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ActivadesRegimenHEDTO, DataActividadSave, DetalleActividadPlanHEDTO, ServidorPlanificado, ServidorSeleccionado } from './TypesPlanificacionHE';

import Swal from 'sweetalert2';


import { ReactComponent as EditarSVG } from "./../../../../assets/icons/HorasExtras/editar.svg";
import { ReactComponent as EliminarSVG } from "./../../../../assets/icons/HorasExtras/eliminar.svg";
import { ReactComponent as VerSVG } from "./../../../../assets/icons/HorasExtras/VER.svg";
import RowNoMargin from 'components/Varios/RowNoMargin';
import { DetalleActividadProyHEDTO } from '../ProyeccionHE/TypesProyeccionDirectivo';
import NumberFormat from 'react-number-format';

type PropsTableDetalleActividadHE = {
    estadoPlanificacion: string,
    detalleActividadPlan: DetalleActividadPlanHEDTO[] | DetalleActividadProyHEDTO[],
    onEdit: (actividad: DataActividadSave) => void;
    onDelete: (data: DataActividadSave, actividad: string) => Promise<void>
    mensajeNovedad: string,
    idEstructura: number,
    tipo: "PR" | "PL" | "MD",
    puedeRealizarAccion?: boolean

}

function CalcularTotalHoras(serv: DetalleActividadPlanHEDTO | DetalleActividadProyHEDTO) {
    var totalHoras: number | undefined = undefined
    if (serv.horasExtraordinarias || serv.horasSuplementarias) {
        totalHoras = (serv.horasExtraordinarias ?? 0) + (serv.horasSuplementarias ?? 0)
    }

    return totalHoras
}

export default function TableDetalleActividadHE(props: PropsTableDetalleActividadHE) {
    const { detalleActividadPlan, onEdit, onDelete, puedeRealizarAccion } = props;
    const [modalOpen, setModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortColumn, setSortColumn] = useState<string | null>('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);
    const [selectedServidores, setSelectedServidores] = useState<ServidorPlanificado[]>([]);
    const [nombreActividad, setNombreActividad] = useState<string>('');

    const estructuraFiltrada = props.idEstructura;

    const filteredActividadesServidores = detalleActividadPlan
        .map(act => ({
            ...act,
            servidoresPlanificados: act.servidoresPlanificados.filter(s => s.value.idestructura === estructuraFiltrada)
        }))
        .filter(act => act.servidoresPlanificados.length > 0) // Excluye las actividades sin servidores


    const filteredActividades = filteredActividadesServidores.filter(act =>
    (act.nombreactividad.toLowerCase().includes(searchTerm.toLowerCase()) ||
        act.nombreregimenLaboral.toLowerCase().includes(searchTerm.toLowerCase()) ||
        act.observacion.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    let currentRows = filteredActividades.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredActividades.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    const applySorting = (data) => {
        if (!sortColumn) return data;

        if (data) {
            const sortedData = [...data].sort((a, b) => {
                if (a && b) {
                    var valA = a[sortColumn];
                    var valB = b[sortColumn];

                    if (sortColumn === "servidores") {
                        valA = a["servidoresPlanificados"].length;
                        valB = b["servidoresPlanificados"].length;
                    }

                    if (sortColumn === "totalHoras") {
                        valA = CalcularTotalHoras(a)
                        valB = CalcularTotalHoras(b)

                    }



                    if (typeof valA === "string" && typeof valB === "string") {
                        // Sort strings using localeCompare
                        return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                    } else if (typeof valA === "number" && typeof valB === "number") {
                        // Sort numbers directly
                        return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                    }

                    // Handle potential cases where types are mixed or unexpected
                    return 0;
                }

                return 0;


            });
            return sortedData;
        }

    };

    const sortedServidores = applySorting(filteredActividades);
    currentRows = sortedServidores.slice(indexOfFirstRow, indexOfLastRow);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1); // Reiniciar a la primera página al cambiar el número de filas por página
    };

    const toggleModal = (servidores?: ServidorPlanificado[], nombreActividad?: string) => {
        if (servidores) {
            setSelectedServidores(servidores.sort((a, b) => a.nombrecompleto.localeCompare(b.nombrecompleto)));
            //setSelectedServidores(servidores);

        }
        if (nombreActividad) {
            setNombreActividad(nombreActividad)
        }
        setModalOpen(!modalOpen);
    };

    const handleEdit = (detalleActividad: DetalleActividadPlanHEDTO | DetalleActividadProyHEDTO) => {
        const dataActividadSave: DataActividadSave = {
            regimenLaboralSeleccionado: detalleActividad.idregimenLaboral, // Asegúrate de asignar el valor correcto
            actividadSeleccionada: detalleActividad.idactividad,
            horasSuplementarias: 0,
            horasExtraordinarias: 0,
            observacion: detalleActividad.observacion,
            servidoresSeleccionados: detalleActividad.servidoresPlanificados,
            grupoSeleccionado: detalleActividad.idgrupoactividad

        };
        onEdit(dataActividadSave);
    };

    const handleDelete = (detalleActividad: DetalleActividadPlanHEDTO) => {
        const dataActividadSave: DataActividadSave = {
            regimenLaboralSeleccionado: detalleActividad.idregimenLaboral, // Asegúrate de asignar el valor correcto
            actividadSeleccionada: detalleActividad.idactividad,
            horasSuplementarias: 0,
            horasExtraordinarias: 0,
            observacion: detalleActividad.observacion,
            servidoresSeleccionados: detalleActividad.servidoresPlanificados
        };
        const nombreActividad = detalleActividad.nombreactividad
        onDelete(dataActividadSave, nombreActividad);
    };

    const mostrarBotones = useMemo(() => {  
        var estadosPuedeGuardar = ['', 'RT', 'RE', 'MO']

        if(props.tipo === "MD"){
            estadosPuedeGuardar = ['', 'AP', 'NE']
        }
        console.log(estadosPuedeGuardar)
        const estadoPlanif = (estadosPuedeGuardar.includes(props.estadoPlanificacion.trim()))
        return estadoPlanif;
    }, [props.estadoPlanificacion]);

    /*const mostrarBotones = useMemo(() => {
        const estadoPlanificacion = (props.estadoPlanificacion === '' || props.estadoPlanificacion.trim() === 'RT' || props.estadoPlanificacion.trim() === 'RE' || props.estadoPlanificacion.trim() === 'MO')
        return estadoPlanificacion && !props.mensajeNovedad;
    }, [props.estadoPlanificacion]);*/
    
    return (
        <React.Fragment>
            <RowNoMargin>
                <Col md="9">
                    <div className="d-flex align-items-center justify-content-start">
                        <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                        <select
                            id="rowsPerPageSelect"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="custom-select custom-select-sm mr-2"
                            style={{ width: 'auto' }}
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        <Label className="mb-0">filas</Label>
                    </div>
                </Col>
                <Col md="3">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control-sm"
                    />
                </Col>
            </RowNoMargin>
            <Table responsive bordered className="table_planificacion_he">
                <thead className="cabeceras_tabla_planificacion_he">
                    <tr className="borde_cabeceras_he">
                        <th onClick={() => handleSort('servidores')}>Núm.<br />Servidores</th>
                        <th onClick={() => handleSort('nombreactividad')} colSpan={2}>Actividad</th>
                        {props.tipo === "PL" && <th onClick={() => handleSort('observacion')} colSpan={2}>Observación</th>}
                        <th onClick={() => handleSort('nombreregimenLaboral')}>Régimen</th>
                        <th onClick={() => handleSort('horasSuplementarias')}>H. Suplementarias<br />por Actividad</th>
                        <th onClick={() => handleSort('horasExtraordinarias')}>H. Extraordinarias<br />por Actividad</th>
                        {
                            (props.tipo === "PR" || props.tipo === "MD") &&
                            <React.Fragment>
                                <th onClick={() => handleSort('totalHoras')}>Total Horas<br />por Actividad</th>
                            </React.Fragment>
                        }
                        {props.tipo === "PL" &&
                            <React.Fragment>
                                <th onClick={() => handleSort('valorhorassuplementarias')}>Valor<br />H. Suplementarias ($)</th>
                                <th onClick={() => handleSort('valorhorasextraordinarias')}>Valor<br />H. Extraordinarias ($)</th>
                                <th onClick={() => handleSort('valorhorasextraordinarias')}>Valor Total ($)</th>
                            </React.Fragment>
                        }



                        <th colSpan={2}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {currentRows.map((serv, idServ) => {

                        var totalHoras: number | undefined = CalcularTotalHoras(serv)


                        return (
                            <React.Fragment key={idServ}>

                                <tr className='rows_tabla_planificacion_he' key={serv.idactividad}>
                                    <td className="centrado">{serv.servidoresPlanificados.length}</td>
                                    <td colSpan={2} title={serv.nombreactividad}>{serv.nombreactividad}</td>
                                    {props.tipo === "PL" && <td colSpan={2} title={serv.observacion}>{serv.observacion}</td>}
                                    <td className="centrado">{serv.nombreregimenLaboral}</td>
                                    <td className="centrado">{serv.horasSuplementarias}</td>
                                    <td className="centrado">{serv.horasExtraordinarias}</td>
                                    {
                                        (props.tipo === "PR" ||props.tipo === "MD") && (
                                            <React.Fragment>
                                                <td className="centrado"> {totalHoras} </td>
                                            </React.Fragment>
                                        )
                                    }
                                    {
                                        props.tipo === "PL" && (
                                            <React.Fragment>
                                                <td className="centrado">
                                                    <div className='containerValorDineroProyectado'>
                                                        <NumberFormat value={serv.valorhorasSuplementarias ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                                    </div>
                                                </td>
                                                <td className="centrado">
                                                    <div className='containerValorDineroProyectado'>
                                                        <NumberFormat value={serv.valorhorasExtraordinarias ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                                    </div>
                                                </td>
                                                <td className="centrado">
                                                    <div className='containerValorDineroProyectado'>
                                                        <NumberFormat value={serv.valortotal ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                                    </div>
                                                </td>
                                            </React.Fragment>
                                        )
                                    }


                                    <td className="centrado" colSpan={2}>
                                        <a className="btn-detalles" title="Ver Servidores" onClick={() => toggleModal(serv.servidoresPlanificados.map(s => s.value), serv.nombreactividad)}><VerSVG className='icono-svg' /></a>
                                        {puedeRealizarAccion && (
                                            <>
                                                {mostrarBotones && (
                                                    <>
                                                        <a className="btn-detalles" title="Editar Actividad" onClick={() => handleEdit(serv)}><EditarSVG className='icono-svg' /></a>
                                                        <a className="btn-detalles" title="Eliminar Actividad" onClick={() => handleDelete(serv)}><EliminarSVG className='icono-svg' /></a>
                                                    </>
                                                )}
                                            </>
                                        )}

                                    </td>
                                </tr>

                            </React.Fragment>
                        )
                    })}
                </tbody>
            </Table>
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>
            <Modal isOpen={modalOpen} toggle={() => toggleModal()} size="xl">
                <ModalHeader toggle={() => toggleModal()}>
                    <div className='tituloModalDocumentos'>Consulta de servidores asignados a la actividad {nombreActividad}</div>
                </ModalHeader>

                <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <div className='table-responsive'  style={{ maxHeight: '60vh', overflowY: 'auto' }} >

                        <Table bordered className="table_planificacion_he">
                            <thead className="cabeceras_tabla_planificacion_he">
                                <tr className="borde_cabeceras_he">
                                    <th>#</th>
                                    <th>Cédula</th>
                                    <th>Nombre Completo</th>
                                    <th>Cargo</th>
                                    <th>Régimen</th>
                                    <th>H. Suplementarias</th>
                                    <th>H. Extraordinarias</th>
                                    <th>Total Horas</th>
                                    {
                                        props.tipo === "PL" &&
                                        <React.Fragment>
                                            <th>Valor H. Suplementarias ($)</th>
                                            <th>Valor H. Extraordinarias ($)</th>
                                            <th>Valor Total ($)</th>
                                        </React.Fragment>
                                    }

                                </tr>
                            </thead>
                            <tbody>
                                {selectedServidores.map((servidor, index) => (
                                    <tr key={index} className='rows_tabla_planificacion_he'>
                                        <td className="centrado">
                                            {index + 1}
                                            {/* <div className='text-right pr-1'>
                                            {index + 1}
                                        </div> */}
                                        </td>
                                        <td>{servidor.identificacion}</td>
                                        <td>{servidor.nombrecompleto}</td>
                                        <td>{servidor.cargo}</td>
                                        <td className='centrado'>{servidor.siglasregimen}</td>
                                        <td className='centrado'>{servidor.horasSuplementarias}</td>
                                        <td className='centrado'>{servidor.horasExtraordinarias}</td>
                                        <td className='centrado'>{(servidor.horasSuplementarias || 0) + (servidor.horasExtraordinarias || 0)}</td>
                                        {
                                            props.tipo === "PL" &&
                                            <React.Fragment>
                                                <td className='centrado'>
                                                    <div className='containerValorDineroProyectado'>
                                                        {servidor.valorhorasSuplementarias?.toFixed(2) ?? ""}
                                                    </div>
                                                </td>
                                                <td className='centrado'>
                                                    <div className='containerValorDineroProyectado'>
                                                        {servidor.valorhorasExtraordinarias?.toFixed(2) ?? ""}
                                                    </div>
                                                </td>
                                                <td className='centrado'>
                                                    <div className='containerValorDineroProyectado'>
                                                        {servidor.valortotal?.toFixed(2) ?? ""}
                                                    </div>
                                                </td>
                                            </React.Fragment>
                                        }


                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => toggleModal()}>Cerrar</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    )
}